<script>
    const axios = require('axios');
    import laroute from './../laroute';
    import _ from 'lodash';
    import trans from '../mixins/trans';

    function getParameterByName(name, _default) {
        let match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        if (match) {
            return decodeURIComponent(match[1].replace(/\+/g, ' '));
        }
        return _default;
    }

    const makeRequestCreator = () => {
        let call = null;
        return (url, params) => {
            // If another request is already running, cancel
            if (call) {
              call.cancel("A new request has been started, so the previous one is canceled.");
            }

            // Create new CancelToken for the new request
            call = axios.CancelToken.source();

            return axios.get(url, {
              cancelToken: call.token,
              params
            }).catch(error => {
                if (axios.isCancel(error)) {
                  // canceled by call.cancel()
                }
            });
        };
    };
    const get = makeRequestCreator();

    let searchUrl = '';

    export default {

        mixins: [
            trans
        ],

        props: [
            'searchquery',
            'initialDifficulties',
            'initialTrainingProviders',
            'initialLengths',
            'categoryId',
            'scoped',
            'language',
        ],

        data() {
            return {
                page: 1,
                hasFiltersInUrl: false, 
                laroute,
                query: '',
                hasSearched: false,
                trainings: {
                    data: []
                },
                filterData: {},
                category: {
                  name: this.__('All Categories'),
                  id: 0,
                },
                subcategory: {
                  name: this.__('All Categories'),
                  id: 0,
                },
                rootCategory: null,
                categorySeo: {
                    title: '',
                    description: '',
                    startblock: '',
                    endblock: ''
                },
                subcategories: [],
                price: '',
                diplomas: [],
                ratings: null,
                languages: [],
                availableLengths: this.initialLengths || [],
                lengths: [],
                difficulties: [],
                availableDifficulties: this.initialDifficulties || [],
                targetAudiences: [],
                availableTrainingProviders: this.initialTrainingProviders || [],
                trainingProvider: '',
                trainingProviderName: this.__('Select provider'),
                selectedLanguage: this.language,
                selectedLanguageName: '',
                sort: {},
                emptyStateChecks: {},
                loading: false,
                sortOptions: [
                    {
                        name: this.__('Recommendation'),
                        context: 'catalog',
                        column: 'recommendation',
                        order: 'ASC'
                    },
                    {
                        name: this.__('Popularity'),
                        context: 'catalog',
                        column: 'sales_count',
                        order: 'DESC'
                    },
                    {
                        name: this.__('by Title, A -> Z'),
                        context: '*',
                        column: 'display_title',
                        order: 'ASC'
                    },
                    {
                        name: this.__('by Title, Z -> A'),
                        context: '*',
                        column: 'display_title',
                        order: 'DESC'
                    },
                    {
                        name: this.__('lowest Price'),
                        context: 'catalog',
                        column: 'price',
                        order: 'ASC'
                    },
                    {
                        name: this.__('newest Trainings'),
                        context: 'my-trainings',
                        column: 'assignment',
                        order: 'DESC'
                    },
                    {
                        name: this.__('greatest Progress'),
                        context: 'my-trainings',
                        column: 'progress_score',
                        order: 'DESC'
                    }
                ],
            }
        },

        mounted() {
            window.onpopstate = (event) => {
              this.applyQueryFilters();
              this.search(this.query);
            };

            this.hasFiltersInUrl = this.expandFilters;

            if (parseInt(this.categoryId) > 0) {
                this.category.id = this.categoryId;
            }


          if (this.scoped) {
                searchUrl = '/trainings/search/scoped';
            } else {
                searchUrl = '/trainings/search';
            }

            if (this.scoped) {
                this.sort = this.sortOptions[2]; /* a to z */
            } else {
                this.sort = this.sortOptions[0]; /* popularity */
            }

            this.query = this.searchquery;

            this.emptyStateChecks = Object.assign({}, {
                query: this.query,
                category: this.category.id,
                language: this.selectedLanguage,
                price: this.price,
                trainingProvider: this.trainingProvider,
                targetAudiences: this.targetAudiences,
                difficulties: this.difficulties
            });

            this.applyQueryFilters();

            if (this.selectedLanguage === 'de') {
                this.selectedLanguageName = this.__('German');
            } else if (this.selectedLanguage === 'en') {
                this.selectedLanguageName = this.__('English');
            } else {
                this.selectedLanguageName = this.__('All Languages');
            }

            // Create resize observer
            const observer = new ResizeObserver(entries => {
                entries.forEach(entry => {
                    if ($('#filterButton').length > 0) {
                        var __style = document.getElementById('_style')
                        var __newStyle = document.createElement('style')

                        __newStyle.id = '_style'
                        __newStyle.innerHTML = `
                            .filterbar + .collapse.tipped::before, .filterbar + .collapse.tipped::after, .filterbar + .collapsing.tipped::before, .filterbar + .collapsing.tipped::after {
                              left: ${$('#filterButton').position().left + $('#filterButton').width() / 2}px;
                            }
                            `

                        if (__style === null) {
                            __style = document.createElement("style");
                            __style.id = '_style';

                            document.head.append(__style);
                        }

                        __style.parentNode.replaceChild(__newStyle, __style);
                    }
                });
            });
            observer.observe(document.getElementById('content'));

            this.search(this.query, true);
        },

        computed: {
            expandFilters() {
                return  getParameterByName('price', '') !== '' ||
                        getParameterByName('trainingProvider', '') !== '' ||
                        getParameterByName('targetAudiences', '') !== '' ||
                        getParameterByName('difficulties', '') !== '';
            },

            showEmptyState() {
                return this.hasSearched && this.trainings.data.length === 0;
            },
        },

        watch: {

            query: _.debounce(function() {
                this.updateHistory();

                this.search(this.query);
            }, 300),

            selectedLanguage: _.debounce(function() {
                this.search(this.query);
            }, 300)

        },

        methods: {
            removeValue(array, value) {
                const index = this[array].indexOf(value);

                if (index > -1) {
                  this[array].splice(index, 1);
                }

                this.updateHistory();
                this.search(this.query);
            },

            getFilterCount(filter, label) {
                try {
                    return this.filterData[filter][label] || 0
                } catch (err) {
                    return 0
                }
            },

            paginate(page) {
                this.page = page;

                this.updateHistory();
                this.loading = true;

                get(searchUrl, {
                    q: this.query,
                    categoryId: this.category.id,
                    sortColumn: this.sort.column,
                    sortOrder: this.sort.order,
                    price: this.price,
                    trainingProvider: this.trainingProvider,
                    targetAudiences: this.targetAudiences,
                    difficulties: this.difficulties,
                    languages: this.languages,
                    ratings: this.ratings,
                    lengths: this.lengths,
                    page: this.page
                }).then(data => {
                    if (data != null) {
                        this.trainings = data.data.trainings;
                    }

                    this.updateDataLayer();
                    window.scrollTo(0,0);
                })
                .catch(error => {
                    // error callback because of cancellation
                })
                .finally(() => {
                    this.loading = false;
                });
            },

            search(query, maintainPage = false) {
                this.loading = true;

                if (! maintainPage) {
                    this.page = 1;
                    this.updateHistory();
                }

                get(searchUrl, {
                    q: query,
                    page: this.page,
                    categoryId: this.category.id,
                    sortColumn: this.sort.column,
                    sortOrder: this.sort.order,
                    price: this.price,
                    trainingProvider: this.trainingProvider,
                    targetAudiences: this.targetAudiences,
                    difficulties: this.difficulties,
                    languages: this.languages,
                    ratings: this.ratings,
                    lengths: this.lengths,
                }).then(data => {
                    this.hasSearched = true;
                    if (data != null) {
                      this.trainings = data?.data.trainings;
                      this.filterData = data?.data.filters;
                    }
                    this.updateDataLayer();
                  })
                  .catch(error => {
                        // error callback because of cancellation
                  })
                  .finally(() => {
                      this.loading = false;
                  });
            },

            updateDataLayer() {
                let dataLayerTrainings = [];

                this.trainings.data.forEach((training) => {
                    dataLayerTrainings.push({
                        'id': training.id,
                        'externalId': training.external_id,
                        'title': training.display_title,
                        'category': training.default_category ? training.default_category.title : ""
                    });
                });

                window.dataLayer.push({
                    'trainings': dataLayerTrainings
                });
            },

            updateHistory() {
                window.history.pushState('', '', `?q=${this.query}&categoryId=${this.category.id}&price=${this.price}&trainingProvider=${this.trainingProvider}&targetAudiences=${this.targetAudiences}&difficulties=${this.difficulties}&languages=${this.languages}&lengths=${this.lengths}&ratings=${this.ratings}&diplomas=${this.diplomas}&page=${this.page}`);
                window.storeTrainingBackwardsLink();
            },

            applyQueryFilters() {
                // Lookup query parameters...
                this.query = getParameterByName('q', this.query);
                this.category.id = getParameterByName('categoryId', this.categoryId);

                if (parseInt(this.category.id) > 0) {
                    this.fetchCategory(this.categoryId);
                }

                this.price = getParameterByName('price', this.price);
                this.trainingProvider = getParameterByName('trainingProvider', this.trainingProvider);
                this.trainingProviderName = this.availableTrainingProviders[this.trainingProvider] || this.__('Select provider')
                this.page = getParameterByName('page', this.page);

                let difficulties = getParameterByName('difficulties', '');
                if (difficulties !== '') {
                    this.difficulties = difficulties.split(',');
                }

                let targetAudiences = getParameterByName('targetAudiences', '');
                if (targetAudiences !== '') {
                    this.targetAudiences = targetAudiences.split(',');
                }

                let lengths = getParameterByName('lengths', '');
                if (lengths !== '') {
                  this.lengths = lengths.split(',');
                }

                let ratings = getParameterByName('ratings', '');
                if (ratings !== '') {
                  this.ratings = ratings;
                }

                let languages = getParameterByName('languages', '');
                if (languages !== '') {
                  this.languages = languages.split(',');
                }
            },

            fetchCategory(id) {
                if (parseInt(id) > 0) {
                    axios.get(`/api/categories/${id}`)
                        .then(response => {
                          if (response.data.root === null) {
                            this.subcategory.name = null;
                            this.subcategory.color = null;
                            this.category.name = response.data.locale_title;
                            this.category.color = response.data.color;
                            this.rootCategory = null;
                          } else {
                            this.subcategory.name = response.data.locale_title;
                            this.subcategory.color = response.data.color;
                            this.rootCategory = response.data.root.id;
                            this.category.name = response.data.root.locale_title;
                            this.category.color = response.data.root.color;
                          }
                          this.categorySeo.title = response.data.locale_seo_title;
                          this.categorySeo.description = response.data.locale_seo_description;
                          this.categorySeo.startblock = response.data.rendered_seo_startblock;
                          this.categorySeo.endblock = response.data.locale_seo_endblock;

                          this.subcategories = response.data.children;

                          this.updateSeoContainers();
                        })
                        .catch(() => {
                          this.category.name = null;
                          this.category.color = null;
                          this.categorySeo.title = null;
                          this.categorySeo.description = null;
                          this.categorySeo.startblock = null;
                          this.categorySeo.endblock = null;
                          this.subcategory.name = null;
                          this.subcategory.color = null;
                          this.subcategories = [];
                        });
                }
            },

            updateSeoContainers() {
                this.$refs.descriptionContainer.textContent = this.categorySeo.description;
                this.$refs.startblockContainer.innerHTML = this.categorySeo.startblock;
            },

            useSort(sortOption) {
                this.sort = sortOption;
                this.search(this.query);
            },

            useCategory(id) {
                this.category.id = id;
                this.fetchCategory(id);
                this.updateHistory();
                this.search(this.query);
            },

            useLanguage(lang, langName) {
                this.selectedLanguage = lang;
                this.selectedLanguageName = langName;

                this.updateHistory();

                this.search(this.query);
            },

            usePrice(){
                this.price = parseInt(this.price) ? parseInt(this.price) : '';

                this.updateHistory();

                this.search(this.query);
            },

            useTrainingProvider(provider){
                this.trainingProvider = provider;
                this.trainingProviderName = this.availableTrainingProviders[provider] || this.__('Select provider');

                this.updateHistory();

                this.search(this.query);
            },

            useTargetAudiences(){
                this.updateHistory();

                this.search(this.query);
            },

            useDifficulties(){
                this.updateHistory();
                this.search(this.query);
            },

            useLanguages(){
                this.updateHistory();
                this.search(this.query);
            },

            useRatings(){
                this.updateHistory();
                this.search(this.query);
            },

            useLengths(){
                this.updateHistory();
                this.search(this.query);
            },

            useDiplomas(){
                this.updateHistory();
                this.search(this.query);
            },

            showTraining(route, training) {
                 document.location.href = laroute.route(route, {'training': training.slug, 'category': training.default_category.slug})
            }
        }
    }
</script>